import { render, staticRenderFns } from "./template.vue?vue&type=template&id=37d1de6e&scoped=true&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=37d1de6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../agent-app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d1de6e",
  null
  
)

export default component.exports